import { useCallback, useEffect, useMemo } from 'react';
import { useApplicationContext } from '../components/ApplicationContext';
import { createMicrofrontendAPI } from '../../browser/services/microfrontends/createMicrofrontendAPI';
import { useCheckPaymentQueue } from './useCheckPaymentQueue';
import { updateDepositAccountPaymentToken } from '../actions/depositAccount';
import { loadPublishTerms } from '../redux/reducers';
import { useDispatch } from 'react-redux';
import { IBuyPackageParams, TMicrofrontendsAPI } from '../types/microfrontends/buyPackage';

export const useBuyPackage = () => {
  const { microfrontend } = useApplicationContext();
  const dispatch = useDispatch();
  const { runCheckPaymentQueue } = useCheckPaymentQueue();

  const payPackageApi = useMemo<TMicrofrontendsAPI>(() => {
    return createMicrofrontendAPI(microfrontend!);
  }, [microfrontend]);

  const buyPackage = useCallback(
    (params: IBuyPackageParams) => {
      payPackageApi.buyPackage(params);
    },
    [payPackageApi],
  );

  const onPaymentStatusChange = useCallback(
    (e: CustomEvent) => {
      // Если вернулся confirmationToken, значит пополнение было через юмани, нужно проверить статус платежа
      if (e.detail.confirmationToken) {
        dispatch(updateDepositAccountPaymentToken(e.detail.confirmationToken.substring(3)));
        runCheckPaymentQueue();
      } else {
        dispatch(loadPublishTerms());
      }
    },
    [dispatch, runCheckPaymentQueue],
  );

  useEffect(() => {
    window.addEventListener('payment-success', onPaymentStatusChange);

    return () => {
      window.removeEventListener('payment-success', onPaymentStatusChange);
    };
  }, [onPaymentStatusChange]);

  return {
    buyPackage,
  };
};
